import { RootReducer } from 'store/reducers';
import { createSelector } from 'reselect';

export const documentError = (state: RootReducer) => state.document.error;

export const isDocumentError = createSelector(
  documentError,
  (documentError): boolean => !!documentError
);
